import JourneyTemplate from '@/models/JourneyTemplates/JourneyTemplateDto';
import RateCardDto from '@/models/RateCards/RateCardDto';

export default class EditTimesheetOptionsResponse {
    journeyTemplates: JourneyTemplate[] = [];  
    passengerDeductionOneWay: number;
    passengerDeductionRoundTrip: number;
    driverUnitExpenseChargeRate: number;
    driverUnitExpensePayRate: number;
}


